export class CybermetrieParamsJAMPP {
    noDemande?: string;
    parcours?: string
}